// Единственное место, где AI-сайдбар связан с данными курса: превращает
// выделение из editorSlice в человекочитаемый контекст для чипа и сообщений.
import { skipToken } from '@reduxjs/toolkit/query/react'
import type { CourseWithoutBlocks } from '@/types/course'
import { useGetLessonBlocksQuery } from '@/features/editor/lessonsApi'
import { useAppSelector } from '@/store/hooks'
import { typeIcon, typeLabel } from '../blockTypeLabels'
import type { BlockContext } from './types'

export const useSelectedBlockRef = (course: CourseWithoutBlocks): BlockContext | null => {
  const selectedLessonId = useAppSelector((s) => s.editor.selectedLessonId)
  const selectedBlockId = useAppSelector((s) => s.editor.selectedBlockId)
  const { data: blocks = [] } = useGetLessonBlocksQuery(selectedLessonId ?? skipToken)

  if (selectedBlockId === null) return null
  const blockIndex = blocks.findIndex((b) => b.id === selectedBlockId)
  if (blockIndex < 0) return null

  // Урок мог уехать из-под выделения (удалили, курс ещё не перезапросили).
  // Контекст либо валиден целиком, либо его нет: он навсегда впечатывается
  // в историю чата, и полузаполненная форма пережила бы там сам курс.
  const lessonIndex = course.lessons.findIndex((l) => l.id === selectedLessonId)
  if (lessonIndex < 0) return null

  const block = blocks[blockIndex]

  return {
    label: typeLabel(block),
    icon: typeIcon(block),
    lessonOrder: lessonIndex + 1,
    blockOrder: blockIndex + 1,
  }
}
